<!-- =========================================================================================
  File Name: ECommerceCheckout.vue
  Description: eCommerce Checkout page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="ecommerce-checkout-demo">
    <form-wizard
      ref="checkoutWizard"
      color="rgba(var(--vs-success), 1)"
      :title="null"
      :subtitle="null"
      :hide-buttons="true"
    >

      <!-- Order summary -->
      <tab-content title="Carrito" icon="feather icon-shopping-cart">
        <vs-prompt
          title="Para continuar debe iniciar sesión"
          @cancel="email=''"
          @accept="close"
          @close="close"
          acceptText="Aceptar"
          cancelText="Cancelar"
          :active.sync="activePrompt">
          <div class="con-exemple-prompt">
            <h3 class="mb-2">Acceso</h3>
            <p class="mb-2 text-sm">Seleccione el método de acceso</p>
            <div class="social-login-buttons flex flex-col items-center mt-4">

              <!-- GOOGLE -->
              <div class="flex flex-row items-center bg-google rounded-lg cursor-pointer mb-3 h-16 w-48 md:w-64" @click="loginWithGoogle">
                <img class="m-2 h-8" src="@/assets/images/logo/GoogleIcon.png" alt="Acceso por Google">
                <div class="h-full w-px bg-white"></div>
                <div class="flex text-white items-center text-sm m-4 border-l-2 border-white">Acceder con Google</div>
              </div>

              <!-- facebook -->
              <div class="flex flex-row items-center bg-facebook rounded-lg cursor-pointer h-16 w-48 md:w-64" @click="loginWithFacebook">
                <img class="m-2 h-8" src="@/assets/images/logo/facebookIcon.png" alt="Acceso por Google">
                <div class="h-full w-px bg-white"></div>
                <div class="flex text-white items-center text-sm m-4 border-l-2 border-white">Acceder con facebook</div>
              </div>

            </div>
          </div>
        </vs-prompt>

        <!-- IF CART HAVE ITEMS -->
        <div class="vx-row" v-if="cartItems.length">

          <!-- LEFT COL -->
          <div class="vx-col w-full lg:w-2/3 mr-3 lg:mr-0">
            <div class="items-list-view" v-for="(item, index) in cartItems" :key="item.code">
              <item-list-view :item="item" class="ml-4 mb-base">

                <!-- SLOT: ITEM META -->
                <template slot="item-meta">
                  <h4
                    class="item-name font-semibold mb-1 cursor-pointer hover:text-primary"
                    @click="$router.push({name: 'item-detail-view', params: {item_id: item.id }}).catch(() => {})">{{ item.name }}</h4>
                  <span class="text-blue">{{ item.description }}</span>
                  <p class="text-success font-bold text-xl">Q{{ item.price.toFixed(2) }}</p>

                  <p class="mt-6 font-bold text-sm">Cantidad</p>
                  <vs-input-number min="1" max="10" :value="item.quantity" @input="updateItemQuantity($event, index)" class="inline-flex"/>

                  <p class="font-medium text-grey mt-6" v-if="!item.combo"> {{ item.comments }}</p>
                  <ul v-if="item.combo">
                    <li v-for="option in item.couponOptions" :key="option.id">
                      <small class="truncate mb-2"><b>{{ option.name }}</b></small>
                      <ul>
                        <li v-for="productOption in option.products" :key="productOption.id">
                          <small class="truncate mb-2">{{ productOption.qtySelected }} {{ productOption.name }}</small>
                        </li>
                      </ul>
                      <br>
                    </li>
                  </ul>
                  <!--                                    <p class="text-success font-medium">{{ item.discount_in_percentage }}% off {{ item.offers_count }} offers Available</p>-->
                </template>

                <!-- SLOT: ACTION BUTTONS -->
                <template slot="action-buttons">

                  <!-- PRIMARY BUTTON: REMOVE -->
                  <div class="item-view-primary-action-btn p-3 rounded-lg flex flex-grow items-center justify-center cursor-pointer mb-3" @click="removeItemFromCart(item)">
                    <feather-icon icon="XIcon" svgClasses="h-4 w-4"/>
                    <span class="text-sm font-semibold ml-2">ELIMINAR</span>
                  </div>

                  <!--                                    &lt;!&ndash; SECONDARY BUTTON: MOVE-TO/VIEW-IN WISHLIST &ndash;&gt;-->
                  <!--                                    <div class="item-view-secondary-action-btn bg-primary p-3 rounded-lg flex flex-grow items-center justify-center text-white cursor-pointer">-->
                  <!--                                        <feather-icon icon="HeartIcon" />-->
                  <!--                                        <span class="text-sm font-semibold ml-2">WISHLIST</span>-->
                  <!--                                    </div>-->
                </template>
              </item-list-view>
            </div>
          </div>

          <!-- RIGHT COL -->
          <div class="vx-col lg:w-1/3 w-full ml-4 lg:ml-0 pr-3 lg:pr-8">
            <vx-card no-shadow no-radius class="mb-base">
              <!--                            <p class="text-grey mb-3">Opciones</p>-->
              <!--                            <div class="flex justify-between">-->
              <!--                                <span class="font-semibold">Cupones</span>-->
              <!--                                <span class="font-medium text-primary cursor-pointer">Aplicar</span>-->
              <!--                            </div>-->
              <p class="font-semibold mb-3 text-primary">Desglose a pagar</p>
              <div class="flex justify-between mb-2">
                <span class="text-primary">Total a pagar</span>
                <span class="text-primary">Q{{ subTotal.toFixed(2) }}</span>
              </div>
              <div class="flex justify-between mb-2">
                <span class="text-primary">Costo de envío</span>
                <span class="text-success" v-if="shippingCost > 0">Q{{ shippingCost.toFixed(2) }}</span>
                <span class="text-success" v-else>Gratis</span>
              </div>

              <vs-divider/>

              <div class="flex justify-between items-center mb-6">
                <div class="relative">
                  <vs-input
                    label="Código de cupón"
                    v-model="couponCode"
                    @change="validateCoupon"
                    :success="couponName != ''"
                    :success-text="couponName"
                    :danger="couponError != ''"
                    :danger-text="couponError"
                  />
                  <div slot="submit-icon" class="hidden sm:block absolute top-0 right-0 bg-success rounded-r mt-6 items-center cursor-pointer" style="height: 36px;" @click="validateCoupon" v-if="couponCode.trim() != ''">
                    <feather-icon icon="CheckIcon" svgClasses="h-8 w-10 text-white mt-1"/>
                  </div>
                </div>
                <div class="text-success" v-show="discount > 0">-Q{{ discount.toFixed(2) }}</div>
              </div>

              <vs-divider/>

              <div class="flex justify-between font-semibold mb-3">
                <span class="text-primary">Total</span>
                <span class="text-primary">Q{{ orderTotal.toFixed(2) }}</span>
              </div>

              <vs-button class="w-full bg-success" @click="nextStep">SIGUIENTE: DIRECCIÓN DE ENVÍO</vs-button>
            </vx-card>
          </div>
        </div>

        <!-- IF NO ITEMS IN CART -->
        <vx-card title="No hay productos en el pedido" v-else>
          <vs-button class="bg-success" @click="$router.push('/').catch(() => {})">Agregue productos</vs-button>
        </vx-card>

      </tab-content>

      <!-- Shipping address -->
      <tab-content title="Dirección de envío" icon="feather icon-home">
        <address-view :isAddressActive="addressWindowActive" :email="activeUserInfo.email" :id="activeUserInfo.addresses.length + 1" @closeAddress="addressWindowActive = false"/>
        <div class="vx-row">
          <!-- LEFT COL FOR BIG SCREENS -->
          <div class="vx-col hidden lg:block lg:w-1/3 mr-3 lg:mr-0">
            <div class="items-list-view" v-for="item in cartItems" :key="item.code">
              <item-list-view :item="item" class="ml-4 mb-base">

                <!-- SLOT: ITEM META -->
                <template slot="item-meta">
                  <b
                    class="item-name font-semibold mb-1 cursor-pointer hover:text-primary"
                    @click="$router.push({name: 'item-detail-view', params: {item_id: item.id }}).catch(() => {})">{{ item.name }}</b>
                  <p class="text-success font-bold text-xl">{{ item.quantity }} x Q{{ item.price.toFixed(2) }}</p>
                </template>
              </item-list-view>
            </div>
            <div class="w-full text-right text-success text-xl mb-2" v-if="couponName != ''">
              <b>{{ couponName }}: -Q{{ discount.toFixed(2) }}</b>
            </div>
            <div class="w-full text-right text-black text-3xl">
              <b>Total: Q{{ orderTotal.toFixed(2) }}</b>
            </div>
          </div>

          <!-- RIGHT COL -->
          <div class="vx-col lg:w-2/3 w-full ml-4 lg:ml-0 pr-3 lg:pr-8">
            <vx-card class="mb-base">
              <div class="flex items-center w-full">
                <vs-input class="w-full" label-placeholder="Escriba su nombre" v-model="customerInfo.name"/>
              </div>
              <div class="flex items-center w-full">
                <vs-input class="w-full" label-placeholder="Escriba su dirección completa" v-model="customerInfo.address"/>
              </div>
              <div class="flex w-full mt-5">
                <v-select :options="states" label="name" clearSearchOnSelect class="w-full" placeholder="Seleccione departamento" v-model="customerInfo.selectedState">
                  <div slot="no-options">No se encontraron departamentos</div>
                </v-select>
              </div>
              <div class="flex w-full mt-5">
                <v-select :options="cities" label="name" clearSearchOnSelect class="flex-1" placeholder="Seleccione municipio" v-model="customerInfo.selectedCity">
                  <div slot="no-options">No se encontraron municipios</div>
                </v-select>
              </div>
              <div class="flex items-center w-full mt-5">
                <vs-input class="w-full" label-placeholder="Especifique instrucciones especiales de despacho" v-model="customerInfo.deliveryInstructions"/>
              </div>
              <div class="flex items-center w-full mt-5">
                <vs-input class="w-full" label-placeholder="Número de teléfono" type="number" v-model="customerInfo.phone"/>
              </div>
              <div class="flex items-center w-full mt-5">
                <vs-input class="w-full" label-placeholder="Correo electrónico" type="email" v-model="customerInfo.email"/>
              </div>
              <vs-button class="w-full mt-5 bg-success" @click="toPayment">SIGUIENTE: DATOS DE PAGO</vs-button>
            </vx-card>
          </div>

          <!-- PRODUCT LIST IN SMALL SCREENS -->
          <div class="vx-col w-full lg:hidden mr-3 lg:mr-0">
            <div class="items-list-view" v-for="item in cartItems" :key="item.code">
              <item-list-view :item="item" class="ml-4 mb-base">

                <!-- SLOT: ITEM META -->
                <template slot="item-meta">
                  <b
                    class="item-name font-semibold mb-1 cursor-pointer hover:text-primary"
                    @click="$router.push({name: 'item-detail-view', params: {item_id: item.id }}).catch(() => {})">{{ item.name }}</b>
                  <p class="text-success font-bold text-xl">{{ item.quantity }} x Q{{ item.price.toFixed(2) }}</p>
                </template>
              </item-list-view>
            </div>
            <div class="w-full text-right text-black text-3xl">
              <b>Total: Q{{ orderTotal.toFixed(2) }}</b>
            </div>
          </div>
        </div>
      </tab-content>

      <tab-content title="Datos de pago" icon="feather icon-credit-card">

        <div class="vx-row">

          <!-- LEFT COL: PAYMENT OPTIONS -->
          <div class="vx-col w-full lg:w-2/3 mr-3 lg:mr-0">
            <vx-card no-radius no-shadow title="Opciones de pago" subtitle="Asegúrese de seleccionar la forma de pago correcta" class="ml-4 mb-base">

              <div class="mt-3">
                <ul>
                  <!-- OPTION 1 -->
                  <li v-show="creditCardType == 1">
                    <!-- CARD DETAILS -->
                    <div class="flex flex-wrap">
                      <div class="flex items-center w-full mb-4">
                        <vs-radio v-model="paymentMethod" vs-value="1">
                          Tarjeta de crédito o débito
                        </vs-radio>
                      </div>
                      <div class="w-full ml-8 md:pr-4 mb-2" v-if="paymentMethod == 1">
                        Se le enviará un enlace para efectuar el pago.
                      </div>
                    </div>
                  </li>

                  <vs-divider class="my-6" v-show="creditCardType == 1"/>

                  <!-- OPTION 1 -->
                  <li v-show="creditCardType == 2">
                    <!-- CARD DETAILS -->
                    <div class="flex flex-wrap">
                      <div class="flex items-center w-full mb-4">
                        <vs-radio v-model="paymentMethod" vs-value="2">
                          Tarjeta de crédito o débito
                        </vs-radio>
                      </div>
                      <div class="w-full md:w-1/3 md:pr-4 mb-2" v-if="paymentMethod == 2">
                        <vs-input
                          class="w-full"
                          label-placeholder="Número de tarjeta"
                          :value="cardNumber"
                          @input="validateCardNumber($event)"
                          v-mask="['#### #### #### ####']"
                          :danger="!validCard"
                          danger-text="Número de tarjeta no es válido"
                        />
                      </div>
                      <div class="w-full md:w-2/3 mb-2" v-if="paymentMethod == 2">
                        <vs-input class="w-full" label-placeholder="Nombre en la tarjeta" v-model="cardName"/>
                      </div>
                      <div class="flex flex-row items-center justify-start w-full mt-2" v-if="paymentMethod == 2">
                        <!--                        <vs-input label-placeholder="Vence (MMAA)" type="number" v-model="dueDate" class="w-32"/>-->
                        <vs-select class="w-32 mr-2" label="Mes vencimiento" v-model="cardExpireMonth">
                          <vs-select-item v-for="item in months" :key="item.value" :text="`${item.value}`" :value="item.value"/>
                        </vs-select>
                        <vs-select class="w-32 mr-2" label="Año vencimiento" v-model="cardExpireYear">
                          <vs-select-item v-for="item in years" :key="item.value" :text="`${item.value}`" :value="item.value"/>
                        </vs-select>
                        <vs-input label-placeholder="CVV" type="number" v-model="cvv" class="ml-4 w-24"/>
                      </div>
                      <div class="flex flex-row items-center justify-start w-full mt-4" v-if="paymentMethod == 2">
                        <font-awesome-icon :icon="visaIcon" class="h-16 w-24"/>
                        <font-awesome-icon :icon="masterIcon" class="h-16 w-24"/>
                      </div>
                    </div>
                  </li>

                  <vs-divider class="my-6" v-show="creditCardType == 2"/>

                  <!-- OPTION 2 -->
                  <!--                  <li class="mt-2" v-if="showCashPayment">-->
                  <li class="mt-2" v-show="showCashPayment">
                    <vs-radio v-model="paymentMethod" vs-value="3">Efectivo</vs-radio>
                  </li>
                </ul>
              </div>
            </vx-card>
          </div>

          <!-- RIGHT COL: PRICE -->
          <div class="vx-col lg:w-1/3 w-full ml-4 lg:ml-0 pr-3 lg:pr-8">
            <vx-card no-radius no-shadow title="Detalle de pago">

              <div class="flex justify-between mb-2">
                <span>Precio de {{ itemsInCart }} producto{{ itemsInCart > 1 ? 's' : '' }}</span>
                <span class="font-semibold">Q{{ orderTotal.toFixed(2) }}</span>
              </div>
              <div class="flex justify-between mb-2">
                <span>Peso aproximado</span>
                <span class="font-semibold">{{ aproxWeight }} Lbs.</span>
              </div>
              <div class="flex justify-between mb-2">
                <span>Tienda que entrega</span>
                <span class="font-semibold">{{ originStore }}</span>
              </div>
              <div class="flex justify-between mb-2">
                <span>Costo de envío</span>
                <span class="text-success" v-if="insideCoverage">Gratis</span>
                <span class="text-success" v-else>
                  Entregado por Cargo Expreso
                </span>
              </div>
              <div class="flex justify-between mb-2" v-if="!insideCoverage">
                <span></span>
                <span class="text-success">
                   <a href="https://www.cargoexpreso.com/cotizador/" target="_blank">Consulte precios aquí</a>
                </span>
              </div>

              <vs-divider/>

              <div class="flex justify-between">
                <span>Monto a pagar</span>
                <span class="font-semibold">Q{{ orderTotal.toFixed(2) }}</span>
              </div>

              <vs-divider/>

              <span class="font-bold"><b>Datos para facturación</b></span>
              <div class="flex justify-between mt-2">
                <vx-tooltip position="top" text="Desmarque esta opción si necesita factura con NIT">
                  <vs-checkbox v-model="finalConsumer">Consumidor final</vs-checkbox>
                </vx-tooltip>
              </div>
              <div class="vx-row">
                <div class="vx-col w-full">
                  <!--                              <span style="height: 7px !important;" v-if="!finalConsumer">&nbsp;</span>-->
                  <div class="flex justify-between mt-4 mb-2" v-if="!finalConsumer">
                    <vs-input
                      label-placeholder="NIT"
                      name="VAT"
                      v-model="customerInfo.VAT"
                      @keypress.enter.prevent="submitVAT"
                      @blur="submitVAT"
                      class="w-full"/>
                  </div>
                  <div class="flex justify-between mb-2" v-if="!finalConsumer">
                    <vs-input
                      label-placeholder="Nombre"
                      name="nameVAT"
                      v-model="customerInfo.nameVAT"
                      class="w-full"
                      readonly=true
                    />
                  </div>

                </div>
              </div>

              <vs-divider/>

              <!--              <div style="width: 100px; height: 100px; border: 0; position:absolute; top: 0;" :src="cyberSourceLink"></div>-->

              <vs-button class="w-full bg-success" @click="placeOrder">COLOCAR ORDEN</vs-button>

            </vx-card>
          </div>
        </div>
      </tab-content>

    </form-wizard>
  </div>
</template>

<script>
import {firebase, db} from '@/firebaseConfig'
import {FormWizard, TabContent} from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import vSelect from 'vue-select';
import {mask} from 'vue-the-mask';
import luhn from 'luhn';
import Vue from 'vue';
import {VueReCaptcha} from 'vue-recaptcha-v3';
import {gmapApi} from 'vue2-google-maps';
import states from '@/store/data/states.json';
import cities from '@/store/data/cities.json';
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';
import {faCcVisa} from '@fortawesome/free-brands-svg-icons';
import {faCcMastercard} from '@fortawesome/free-brands-svg-icons';

Vue.use(VueReCaptcha, {siteKey: '6Le9p7cZAAAAAOc855TzyHruZOieZYOeY4rFGjgP'});

export default {
  directives: {mask},
  data() {
    return {
      visaIcon: faCcVisa,
      masterIcon: faCcMastercard,
      addressWindowActive: false,
      couponCode: '',
      couponName: '',
      couponError: '',
      discount: 0,
      email: '',
      activePrompt: false,
      customerInfo: {
        name: '',
        address: '',
        phone: '',
        email: '',
        selectedState: {"id": 1, "name": "Guatemala"},
        selectedCity: {"id": 101, "stateId": 1, "name": "Guatemala"},
        selectedName: null,
        selectedVAT: null,
        selectedEmail: '',
        store: '',
        deliveryInstructions: '',
        VAT: '',
        nameVAT: '',
        addressVAT: '',
        validatedVAT: false,
        names: [],
        addresses: [],
        taxIds: []
      },
      currentAddress: [],
      selectedAddress: null,

      // TAB 2
      fullName: '',
      mobileNum: '',
      pincode: '',
      houseNum: '',
      area: '',
      landmark: '',
      city: '',
      state: '',
      addressType: 1,
      addressTypeOptions: [
        {text: 'Home', value: 1},
        {text: 'Office', value: 2}
      ],

      // TAB 3
      paymentMethod: 0,
      cardNumber: '',
      cardName: '',
      dueDate: '',
      cardExpireMonth: ('0' + (new Date().getMonth() + 1)).slice(-2),
      cardExpireYear: new Date().getFullYear(),
      cvv: '',
      validCard: false,
      validDue: true,
      finalConsumer: false
    }
  },
  computed: {
    google: gmapApi,

    creditCardType() {
      return this.$store.getters['getParameter']('orders').creditCardType;
    },

    validateCardAPI() {
      return this.$store.getters['getParameter']('orders').validateCardAPI;
    },

    odooAPI() {
      return this.$store.getters['getParameter']('orders').odooAPI;
    },

    vatAPI() {
      return this.$store.getters['getParameter']('orders').vatAPI;
    },

    shippingCost1() {
      return this.$store.getters['getParameter']('orders').shippingCost1;
    },

    shippingLimit1() {
      return this.$store.getters['getParameter']('orders').shippingLimit1;
    },

    shippingCost2() {
      return this.$store.getters['getParameter']('orders').shippingCost2;
    },

    location1() {
      return this.$store.getters['getParameter']('orders').locationGuatemala.split(',');
    },

    location2() {
      return this.$store.getters['getParameter']('orders').locationQuetzaltenango.split(',');
    },

    orderMinimum() {
      return this.$store.getters['getParameter']('orders').orderMinimum;
    },

    showCashPayment() {
      return this.$store.getters['getParameter']('orders').showCashPayment;
    },

    cartItems() {
      return this.$store.state.eCommerce.cartItems.slice().reverse()
    },

    months() {
      return [
        {value: '01'},
        {value: '02'},
        {value: '03'},
        {value: '04'},
        {value: '05'},
        {value: '06'},
        {value: '07'},
        {value: '08'},
        {value: '09'},
        {value: '10'},
        {value: '11'},
        {value: '12'},
      ];
    },
    years() {
      return this.getYears();
    },

    itemsInCart() {
      if (this.cartItems.length > 0) {
        return this.cartItems.map(item => item.quantity).reduce((prev, next) => prev + next);
      } else {
        return 0;
      }
    },
    aproxWeight() {
      return this.itemsInCart * 2;
    },
    shippingCost() {
      /*
              if (this.orderTotal < this.shippingLimit1) {
                return this.shippingCost1;
              } else if (this.selectedAddress) {
                if ([1, 901].includes(this.selectedAddress.cityId)) {
                  return 0;
                } else return this.shippingCost2;
              }
      */
      return 0;
    },
    originStore() {
      if (this.selectedAddress) {
        if (["7", "8", "9", "10", "11", "12", "13", "14"].includes(this.selectedAddress.stateId)) {
          return 'Quetzaltengango';
        } else {
          return 'Guatemala';
        }
      } else {
        return 'Guatemala';
      }
    },
    insideCoverage() {
      if (this.selectedAddress) {
        const pos = new this.google.maps.LatLng(this.selectedAddress.lat, this.selectedAddress.lng);
        if (["7", "8", "9", "10", "11", "12", "13", "14"].includes(this.selectedAddress.stateId)) {
          const pos2 = new this.google.maps.LatLng(parseFloat(this.location2[0]), parseFloat(this.location2[1]));
          return (this.haversine_distance(pos2, pos) <= 5);
        } else {
          const pos1 = new this.google.maps.LatLng(parseFloat(this.location1[0]), parseFloat(this.location1[1]));
          return (this.haversine_distance(pos1, pos) <= 6);
        }
      } else {
        return 1;
      }
    },
    subTotal() {
      if (this.cartItems.length > 0) {
        return this.cartItems.map(item => item.amount).reduce((prev, next) => prev + next);
      } else {
        return 0;
      }
    },
    orderTotal() {
      return this.subTotal - this.discount;
    },
    tax() {
      return Math.round(this.orderTotal * 12 / 112 * 100) / 100;
    },
    activeUserInfo() {
      return this.$store.state.AppActiveUser;
    },
    loggedIn() {
      return this.$store.state.auth.isUserLoggedIn();
    },
    cyberSourceLink() {
      return `https://h.online-metrix.net/fp/tags?org_id=k8vif92ew&session_id=visanetgt_sociedadbiblica${window.uuidv4}`;
    },
    states() {
      return states.states;
    },
    cityList() {
      return cities.cities;
    },
    cities() {
      if (this.customerInfo.selectedState == null) {
        return [];
      } else {
        return cities.cities.filter(item => item.stateId == this.customerInfo.selectedState.id);
      }
    }
  },
  methods: {
    async recaptcha() {
      // (optional) Wait until recaptcha has been loaded.
      await this.$recaptchaLoaded();

      // Execute reCAPTCHA with action "login".
      const token = await this.$recaptcha('login');
      console.log(token);
    },
    getYears() {
      var years = [];
      var year = new Date().getFullYear();
      for (var i = 0; i < 10; i++) {
        years.push({value: year.toString()});
        year++;
      }
      return years;
    },
    openAddress() {
      this.addressWindowActive = true;
    },
    // Google login
    loginWithGoogle() {
      this.$store.dispatch('auth/loginWithGoogle', {self: this, notify: this.$vs.notify})
    },

    // Facebook login
    loginWithFacebook() {
      this.$store.dispatch('auth/loginWithFacebook', {self: this, notify: this.$vs.notify})
    },

    handleSelectedAddress(tr) {
      this.selectedAddress = {
        id: tr.id,
        address: tr.address,
        stateId: tr.stateId,
        stateName: tr.stateName,
        cityId: tr.cityId,
        cityName: tr.cityName,
        lat: tr.lat,
        lng: tr.lng,
        deliveryInstructions: tr.deliveryInstructions || ''
      };
    },

    close: function () {
    },

    validateCoupon() {
      this.discount = 0;
      this.couponName = '';
      this.couponError = '';
      const couponCode = this.couponCode.trim().toUpperCase();
      if (couponCode != '') {
        this.couponCode = couponCode;
        const self = this;
        db.collection('catalogs').doc('coupons').get()
          .then(snapshot => {
            const data = snapshot.data();
            const coupons = data.list.filter(item => (item.code == couponCode && item.statusId == 'ACT'));
            if (coupons.length > 0) {
              const coupon = coupons.pop();
              const startDate = new Date(coupon.startDate.seconds * 1000);
              const endDate = new Date(coupon.endDate.seconds * 1000);
              const now = new Date();
              if (now >= startDate && now <= endDate) {
                let couponValid = true;
                if (coupon.limit) {
                  couponValid = (coupon.used < coupon.quantity);
                }
                if (couponValid) {
                  self.couponName = coupon.name;
                  if (coupon.applicationId == 'T') {
                    if (coupon.typeId == 'P') {
                      self.discount = Math.round(this.orderTotal * coupon.value) / 100;
                    } else {
                      self.discount = coupon.value;
                    }
                  } else {
                    let product;
                    let applyDiscount;
                    let item;
                    for (let i = 0; i < self.cartItems.length; i++) {
                      item = self.cartItems[i];
                      product = self.$store.getters.getProduct(item.id);
                      if (product) {
                        applyDiscount = false
                        if (coupon.applicationId == 'C') {
                          applyDiscount = (product.categoryId == coupon.categoryId);
                        } else if (coupon.applicationId == 'P') {
                          applyDiscount = (product.id == coupon.productId);
                        }
                        if (applyDiscount) {
                          if (coupon.typeId == 'P') {
                            self.discount += Math.round(item.amount * coupon.value) / 100;
                          } else {
                            self.discount += coupon.value;
                          }
                        }
                      }
                    }
                    if (self.discount == 0) {
                      self.couponName = '';
                      self.couponError = `Los productos en el carrito no aplican para el cupón ${couponCode}`;
                    }
                  }
                } else {
                  self.couponError = `El cupón ${couponCode} está agotado`;
                }
              } else {
                self.couponError = `El cupón ${couponCode} no se encuentra vigente`;
              }
            } else {
              self.couponError = `El cupón ${couponCode} no existe`;
            }
          });
      } else {
        this.couponError = 'Cupón no válido';
      }
    },

    toPayment() {
      let message = '';
      this.customerInfo.name = this.customerInfo.name.trim();
      this.customerInfo.address = this.customerInfo.address.trim();
      this.customerInfo.phone = this.customerInfo.phone.trim();
      this.customerInfo.email = this.customerInfo.email.trim();
      if (this.customerInfo.name == '') {
        message += (message == '' ? '' : '<br/>') + 'Debe especificar su nombre';
      }
      if (this.customerInfo.address == '') {
        message += (message == '' ? '' : '<br/>') + 'Debe indicar su dirección completa';
      }
      if (!this.customerInfo.selectedState) {
        message += (message == '' ? '' : '<br/>') + 'Debe seleccionar un departamento';
      }
      if (!this.customerInfo.selectedCity) {
        message += (message == '' ? '' : '<br/>') + 'Debe seleccionar un municipio';
      }
      if (this.customerInfo.phone.length != 8) {
        message += (message == '' ? '' : '<br/>') + 'Debe especificar un número telefónico válido';
      }
      if (this.customerInfo.email == '') {
        message += (message == '' ? '' : '<br/>') + 'Debe especificar una dirección de correo electrónico';
      }
      if (message == '') {
        this.$refs.checkoutWizard.nextTab();
      } else {
        this.$vs.notify({
          title: 'Información incompleta',
          text: message,
          color: 'danger',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          time: 10000
        })
      }
    },

    haversine_distance: function (mk1, mk2) {
      var R = 6371.0710; // Radius of the Earth in kms
      var rlat1 = mk1.lat() * (Math.PI / 180); // Convert degrees to radians
      var rlat2 = mk2.lat() * (Math.PI / 180); // Convert degrees to radians
      var difflat = rlat2 - rlat1; // Radian difference (latitudes)
      var difflon = (mk2.lng() - mk1.lng()) * (Math.PI / 180); // Radian difference (longitudes)

      var d = 2 * R * Math.asin(Math.sqrt(Math.sin(difflat / 2) * Math.sin(difflat / 2) + Math.cos(rlat1) * Math.cos(rlat2) * Math.sin(difflon / 2) * Math.sin(difflon / 2)));
      return d;
    },

    validateCardNumber(event) {
      this.cardNumber = event;
      this.validCard = luhn.validate(this.cardNumber);
    },

    validExpireDate() {
      const now = new Date();
      var valid = false;
      if (this.cardExpireYear > now.getFullYear()) {
        valid = true
      } else if (parseInt(this.cardExpireYear) == now.getFullYear()) {
        valid = (parseInt(this.cardExpireMonth) >= now.getMonth());
      }
      return valid;
    },

    /*
          setSelectedMonth(value) {
            this.cardExpireMonth = value;
            this.validDue = this.validateExpireDate();
          },

          setSelectedYear(value) {
            this.cardExpireYear = value;
            this.validDue = this.validateExpireDate();
          },
    */

    nextStep: function () {
      this.$refs.checkoutWizard.nextTab();
    },

    nextStep1: function () {
      if (this.loggedIn) {
        if (this.activeUserInfo.phone.trim() == '') {
          this.$vs.notify({
            title: 'Número de teléfono faltante',
            text: 'Por favor debe indicar tu número de teléfono en el perfil para poder continuar',
            color: 'warning',
            iconPack: 'feather',
            icon: 'icon-alert-circle'
          })
        } else if (this.orderTotal < this.orderMinimum) {
          this.$vs.notify({
            title: 'Error',
            text: `Su orden debe ser de al menos Q${this.orderMinimum.toFixed(2)} para poder continuar`,
            color: 'warning',
            iconPack: 'feather',
            icon: 'icon-alert-circle'
          });
        } else {
          this.selectedAddress = null;
          if (this.activeUserInfo.addresses.length > 0) {
            this.selectedAddress = this.activeUserInfo.addresses[0];
          }
          this.$refs.checkoutWizard.nextTab();
        }
      } else {
        this.activePrompt = true;
      }
    },
    // TAB 1
    removeItemFromCart(item) {
      this.$store.dispatch('eCommerce/toggleItemInCart', item)
    },
    updateItemQuantity(event, index) {
      const itemIndex = Math.abs(index + 1 - this.cartItems.length)
      this.$store.dispatch('eCommerce/updateItemQuantity', {quantity: event, index: itemIndex})
    },
    // TAB 3
    submitVAT(event) {
      this.$vs.loading({
        text: 'Validando NIT, espere por favor',
        type: 'point'
      });
      var self = this;
      this.customerInfo.nameVAT = '';
      event.preventDefault();
      this.$http.post(this.vatAPI, {
        phoneNumber: this.customerInfo.phone,
        vat: this.customerInfo.VAT
      }).then(response => {
        self.$vs.loading.close();
        if (response.data.success) {
          self.customerInfo.nameVAT = response.data.data.name;
        } else {
          self.customerInfo.nameVAT = '';
          self.$vs.notify({
            title: 'Error al validar NIT',
            text: `No se encontró el NIT ${self.customerInfo.VAT}`,
            color: 'danger'
          });
        }
      }).catch(error => {
        self.$vs.loading.close();
        var errorMessage = '';
        if (error.message) {
          errorMessage = error.message;
        } else if (error.response) {
          errorMessage = error.response.data.ErrorMessage;
        } else {
          errorMessage = 'Error de conectividad'
        }
        self.$vs.notify({
          title: 'Error al validar NIT',
          text: errorMessage,
          color: 'danger'
        });
      })
    },

    placeOrder() {
      if (this.paymentMethod == 0) {
        this.$vs.notify({
          title: 'Error',
          text: 'Debe especificar una forma de pago',
          color: 'danger',
          time: 10000
        });
      } else if (this.paymentMethod == 0 && (this.cardNumber.length < 16 || !this.validCard)) {
        this.$vs.notify({
          title: 'Error',
          text: 'Número de tarjeta no es válido',
          color: 'danger',
          time: 10000
        });
      } else if (this.paymentMethod == 0 && (this.cardName.trim().length < 5)) {
        this.$vs.notify({
          title: 'Error',
          text: 'Nombre de tarjeta incorrecto',
          color: 'danger',
          time: 10000
        });
      } else if (this.paymentMethod == 0 && !this.validExpireDate()) {
        this.$vs.notify({
          title: 'Error',
          text: 'Fecha de vencimiento de tarjeta no es correcta',
          color: 'danger',
          time: 10000
        });
      } else if (!this.finalConsumer && this.customerInfo.nameVAT.trim() == '') {
        this.$vs.notify({
          title: 'Error',
          text: 'NIT especificado no es correcto',
          color: 'danger',
          time: 10000
        });
      } else {
        if (this.creditCardType == 2 && this.paymentMethod == 2) {
          const self = this;
          this.$vs.loading({
            text: 'Autorizando pago con tarjeta, espere por favor',
            type: 'point'
          });
          this.$http.post(this.validateCardAPI, {
            amount: this.orderTotal,
            name: this.cardName,
            email: this.customerInfo.email,
            address: this.customerInfo.address,
            city: this.customerInfo.selectedCity.name,
            cardNumber: this.cardNumber,
            cardExpireMonth: this.cardExpireMonth,
            cardExpireYear: this.cardExpireYear,
            cvv: this.cvv,
            uuid: window.uuidv4
          }).then(response => {
            self.$vs.loading.close();
            var authorized = false;
            if (response.data) {
              if (response.data.text) {
                const data = JSON.parse(response.data.text);
                if (data) {
                  if (data.status) {
                    if (data.status == 'AUTHORIZED') {
                      authorized = true;
                      self.insertOrder();
                    }
                  }
                }
              }
            }
            if (!authorized) {
              self.$vs.notify({
                title: 'Validación de tarjeta',
                text: 'El cargo a la tarjeta no fue autorizado',
                color: 'danger',
                time: 10000
              });
            }
          }).catch(error => {
            self.$vs.loading.close();
            var errorMessage = '';
            if (error.response) {
              errorMessage = error.response.data.ErrorMessage;
            } else if (error.message) {
              errorMessage = error.message;
            } else {
              errorMessage = 'Error de conectividad'
            }
            console.log(errorMessage);
            self.$vs.notify({
              title: 'Validación de tarjeta',
              text: 'El cargo a la tarjeta no fue autorizado',
              color: 'danger',
              time: 10000
            });
          })
        } else {
          this.insertOrder();
        }
      }
    },

    insertOrder() {
      this.$vs.loading({
        text: 'Colocando pedido, espere por favor',
        type: 'point'
      });
      var self = this;
      var data = {
        date: new Date(),
        user: this.customerInfo.email,
        email: this.customerInfo.email,
        userName: this.customerInfo.name,
        vat: (this.finalConsumer ? 'CF' : this.customerInfo.VAT),
        nameVat: (this.finalConsumer ? 'Consumidor final' : this.customerInfo.nameVAT),
        phone: this.customerInfo.phone,
        address: {
          address: this.customerInfo.address,
          stateId: this.customerInfo.selectedState.id,
          stateName: this.customerInfo.selectedState.name,
          cityId: this.customerInfo.selectedCity.id,
          cityName: this.customerInfo.selectedCity.name,
          deliveryInstructions: this.customerInfo.deliveryInstructions || ''
        },
        orderTotal: this.orderTotal,
        status: 'Procesando',
        products: [],
        paymentMethod: this.paymentMethod
      };
      if (this.creditCardType == 2 && this.paymentMethod == 2) {
        data.cardReference = 'XXXX-XXXX-XX' + this.cardNumber.slice(this.cardNumber.length - 6);
      }
      var product = null;
      for (var itemsCount = 0; itemsCount < this.cartItems.length; itemsCount++) {
        product = {
          productId: parseInt(this.cartItems[itemsCount].id),
          isbn: this.cartItems[itemsCount].isbn,
          description: this.cartItems[itemsCount].name,
          price: parseFloat(this.cartItems[itemsCount].price),
          quantity: parseInt(this.cartItems[itemsCount].quantity),
          amount: parseFloat(this.cartItems[itemsCount].amount)
        };
        data.products.push(product);
      }
      db.collection('parameters').doc('orders').update({orderNumber: firebase.firestore.FieldValue.increment(1)})
        .then(() => {
          db.collection('parameters').doc('orders').get()
            .then(doc => {
              if (doc.exists) {
                data.id = doc.data().orderNumber;
                db.collection('orders').add(data)
                  .then(function (docRef) {
                    var message = `Se ha colocado el pedido número ${data.id}, por favor espere instrucciones por correo electrónico`;
                    self.$vs.dialog({
                      type: 'confirm',
                      color: 'success',
                      title: 'Orden colocada',
                      text: message,
                      buttonCancel: 'flat',
                      acceptText: 'Aceptar',
                      cancelText: '',
                      accept: self.resetAndClearCart,
                      cancel: self.resetAndClearCart
                    });
                    self.$vs.loading.close();
                    self.$http.post(self.odooAPI, data)
                      .then(response => {
                        if (response.data.success) {
                          if (response.data.data) {
                            db.collection('orders').doc(docRef.id).update({orderNumber: response.data.data.orderNumber}).then(() => {
                              self.$store.dispatch('bindOrders', self.$store.state.AppActiveUser.email);
                            });
                          }
                        }
                      })
                      .catch(error => {
                        var errorMessage = '';
                        if (error.response) {
                          errorMessage = error.response.data.ErrorMessage;
                        } else if (error.message) {
                          errorMessage = error.message;
                        } else {
                          errorMessage = 'Error de conectividad'
                        }
                        console.log(errorMessage);
                        self.$vs.loading.close();
                      });
                  })
                  .catch((error) => {
                    self.$vs.loading.close();
                    var errorMessage = '';
                    if (error.response) {
                      errorMessage = error.response.data.ErrorMessage;
                    } else if (error.message) {
                      errorMessage = error.message;
                    } else {
                      errorMessage = 'Error de conectividad'
                    }
                    console.log(errorMessage);
                    self.$vs.notify({
                      title: 'Error al colocar orden',
                      text: errorMessage,
                      color: 'danger',
                      iconPack: 'feather',
                      icon: 'icon-alert-circle'
                    });
                  })
              } else {
                self.$vs.notify({
                  title: 'Error al colocar orden',
                  text: 'Se encontró un error al colocar su orden, por favor intente de nuevo',
                  color: 'danger',
                  iconPack: 'feather',
                  icon: 'icon-alert-circle'
                });
              }
            })
        });
    },

    resetAndClearCart() {
      this.resetOrder();
      this.clearCart();
      this.$router.push('/profile');
    },

    resetOrder() {
      this.$refs.checkoutWizard.reset();
      this.finalConsumer = false;
    },

    clearCart() {
      while (this.cartItems.length > 0) {
        this.$store.dispatch('eCommerce/toggleItemInCart', this.cartItems[0]);
      }
      this.payment_method = 0;
    }

  },
  components: {
    FontAwesomeIcon,
    ItemListView: () => import('./components/ItemListView.vue'),
    User: () => import('./components/User.vue'),
    AddressView: () => import('./components/Address'),
    FormWizard,
    TabContent,
    'v-select': vSelect
  }
}
</script>

<style lang="scss" scoped>
#ecommerce-checkout-demo {
  .item-view-primary-action-btn {
    color: #2c2c2c !important;
    background-color: #f6f6f6;
  }

  .item-name {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    -webkit-line-clamp: 2;
  }

  .vue-form-wizard {
    padding-bottom: 0;

    ::v-deep .wizard-header {
      padding: 0;
    }

    ::v-deep .wizard-tab-content {
      padding-right: 0;
      padding-left: 0;
      padding-bottom: 0;

      .wizard-tab-container {
        margin-bottom: 0 !important;
      }
    }
  }
}
</style>
